module.exports = __webpack_public_path__ + "img/nick-cl.639ef63e.jpg";